<template>
  <v-btn
    text
    class="ma-0 pa-0"
    style="text-transform:unset"
    @click="$emit('openTab')"
    :color="colorIcon"
    id="tab-icon"
  >
    <v-icon size="18" class="mt-1" :left="!!text"> {{ icon }} </v-icon>
    {{ text }}
  </v-btn>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "RightSidebarButton",

  props: {
    /**
     * Icon corresponding to tool
     */
    icon: {
      type: String,
      required: true
    },

    /**
     * Name corresponding to tool
     */
    windowName: {
      type: String,
      required: false
    },

    /**
     * Title corresponding to tool
     */
    text: {
      type: String,
      required: false
    }
  },

  computed: {
    /**
     * Sets the icon color.
     * @returns {string}
     */
    colorIcon() {
      let sidebar = this.$store.getters.getCurrentlyOpenTabSidebar;
      return sidebar === this.windowName ? "#32383D" : "#B1B6B9";
    }
  },

  methods: {
    ...mapActions(["setOpenTabSidebar"]),

    /**
     * Open the selected tab
     * @param tab
     */
    openTab(tab) {
      this.setOpenTabSidebar(tab);
    }
  }
};
</script>

<style>
#tab-icon:not(.v-btn--round).v-size--default {
  min-width: fit-content;
}

#tab-icon:before {
  background: none !important;
}

#tab-icon {
  font: normal normal 600 16px/20px Segoe UI;
  letter-spacing: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Network/RightSidebar/RightSidebarButton.vue